import useAzureSpeechProvider from "shared/speech/providers/useAzureSpeechProvider";
import useRealtimeSocketProvider from "shared/speech/providers/useRealtimeSocketProvider";

const requiresRealtimeProvider = (sourceLang, targetLang) => {
    if (!sourceLang || !targetLang) return false;

    return (
        sourceLang.toLowerCase().startsWith("ht") ||
        targetLang.toLowerCase().startsWith("ht")
    );
};

const useSpeechEngine = ({ sourceLanguage, targetLanguage, callbacks }) => {
    const azureProvider = useAzureSpeechProvider(callbacks);
    const realtimeProvider = useRealtimeSocketProvider(callbacks);

    const useRealtime = requiresRealtimeProvider(
        sourceLanguage?.code,
        targetLanguage?.code
    );

    return useRealtime ? realtimeProvider : azureProvider;
};

export default useSpeechEngine;
